import {Check, ChevronRight} from '@material-ui/icons'
import * as React from 'react'
import { breakpoints } from '~components/breakpoints'
import { Kbd } from '~components/Kbd'
import { SmallIcon } from '~components/SmallIcon'
import * as css from './RowButton.css'
export interface RowButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  children: React.ReactNode
  disabled?: boolean
  kbd?: string
  variant?: 'wide' | 'styleMenu'
  isSponsor?: boolean
  isActive?: boolean
  isWarning?: boolean
  hasIndicator?: boolean
  hasArrow?: boolean
}

export const RowButton = React.forwardRef<HTMLButtonElement, RowButtonProps>(
  (
    {
      onClick,
      isActive = false,
      isWarning = false,
      hasIndicator = false,
      hasArrow = false,
      disabled = false,
      isSponsor = false,
      variant,
      kbd,
      children,
      ...rest
    },
    ref
  ) => {
    return (
      <button
        className={css.root}
        ref={ref}
        data-warning={isWarning}
        data-active={isActive}
        disabled={disabled}
        onClick={onClick}
        data-variant={variant}
        {...rest}
      >
        <div className={css.inner}>
          {children}
          {kbd ? <Kbd variant="menu">{kbd}</Kbd> : undefined}
          {hasIndicator && (
            <div className={css.indicator} dir="ltr">
              <SmallIcon>
                <Check />
              </SmallIcon>
            </div>
          )}
          {hasArrow && (
            <SmallIcon>
              <ChevronRight />
            </SmallIcon>
          )}
        </div>
      </button>
    )
  }
)



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/RowButton/RowButton.tsx